import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
import { useStore } from '@/store/store';
import MyPusher from './pusher';
/**
 * @summary バランス情報取得
 */
export const useBalances = () => {
    const store = useStore();
    /**
     * @returns バランス情報のリスト
     */
    const setBalances = () => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/balances`;
        store.state.balances = yield ApiManager.get(url).catch((err) => {
            return Promise.reject(err);
        });
    });
    return { setBalances };
};
/**
 * @summary 保有資産情報の購読
 */
export const balancesSubscriber = (userId) => {
    let channel;
    const store = useStore();
    const subscribe = () => {
        if (userId !== undefined && userId !== null) {
            channel = MyPusher.subscribe(`private-${userId}-balances-table`);
            channel.bind('balances-table-change', flush);
        }
    };
    const unsubscribe = () => {
        channel === null || channel === void 0 ? void 0 : channel.unbind();
        channel === null || channel === void 0 ? void 0 : channel.unsubscribe();
    };
    let stockBalance = [];
    const flush = (newBalances) => {
        // 1秒に一回だけ画面描画させる（フロント負荷軽減のため）
        if (stockBalance.length === 0) {
            setTimeout(() => {
                bind(stockBalance);
                stockBalance = [];
            }, 1000);
        }
        stockBalance = newBalances;
    };
    const bind = (newBalances) => {
        const oldBalances = [...store.state.balances];
        // すでに存在する口座の場合は書き換え
        let replaced = oldBalances.map((old) => {
            const existBalance = newBalances.find((n) => n.account_number === old.account_number);
            if (existBalance) {
                old.balance = Number(existBalance.balance);
                old.onHold = Number(existBalance.onHold);
            }
            return old;
        });
        // 新しいバランスの中に存在しないバランス情報が無いか確認してあれば付け加える
        const notExitsBalances = newBalances.filter((newBalance) => {
            return !oldBalances.some((balance) => balance.account_number === newBalance.account_number);
        });
        if (notExitsBalances.length >= 1) {
            replaced = [...replaced, ...notExitsBalances];
        }
        store.state.balances = replaced;
    };
    return { subscribe, unsubscribe, bind };
};
